import { render, staticRenderFns } from "./customerCases.vue?vue&type=template&id=e669674a&scoped=true"
import script from "./customerCases.vue?vue&type=script&lang=js"
export * from "./customerCases.vue?vue&type=script&lang=js"
import style0 from "./customerCases.vue?vue&type=style&index=0&id=e669674a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e669674a",
  null
  
)

export default component.exports